import React from 'react';
import DownloadManual from './DownloadManual';
import Button from '../DMGComponents/Button';
import { pca, getCurrentUsername } from '../authProvider';

class AuthenticatedHeader extends React.Component {
    render() {
        return (
            <div style={{ display: "flow-root" }}>
                <DownloadManual isUsaVersion={this.props.isUsaVersion} />
                <div id="logOut" style={{ display: "flex", float: "right", alignItems: "center" }}>
                    <div style={{ marginLeft: '16px' }}>{getCurrentUsername()}</div>
                    {this.props.isAdminPage &&
                        <div className="logOutBtnContent" style={{ marginLeft: '16px' }}>
                            <Button type="hover-bottom-left" onClick={() => { if (this.props.history) this.props.history.push('/') }}>FileEx</Button>
                        </div>
                    }
                    {this.props.isAdmin && !this.props.isAdminPage &&
                        <div className="logOutBtnContent" style={{ marginLeft: '16px' }}>
                            <Button type="hover-bottom-left" onClick={() => { if (this.props.history) this.props.history.push('/admin') }}>Administration</Button>
                        </div>
                    }
                    <div className="logOutBtnContent" style={{ marginLeft: '16px' }}>
                        <Button type="hover-bottom-left" onClick={() => { pca.logoutRedirect() }}>Log Out</Button>
                    </div>
                </div>
            </div>
        )
    }
}
export default AuthenticatedHeader;